// @ts-strict

import { Component, Input, OnInit } from '@angular/core';
import { copyToClipboard } from '@app/core/models/helpers';
import { IBannerConfigData } from '@app/core/services/banners/banners.service.types';
import { GlobalNotificationsService } from '@app/core/services/global-notifications/global-notifications.service';
import { NotificationTypes } from '@app/core/services/global-notifications/global-notifications.model';

@Component({
  selector: 'app-product-generated-url',
  templateUrl: './product-generated-url.component.html',
  styleUrls: ['./product-generated-url.component.scss']
})
export class ProductGeneratedUrlComponent implements OnInit {
  @Input() productConfigurationData?: IBannerConfigData;

  public generatedURL = '';

  constructor(private globalNotificationsService: GlobalNotificationsService) {}

  ngOnInit(): void {
    this.generatedURL = this.productConfigurationData?.generatedURL || '';
  }

  public async copyInputMessage(text: string): Promise<void> {
    const { message, success } = await copyToClipboard(text, { successMessage: 'view_translations.link_copied' });
    this.showNotification(message, NotificationTypes[success ? 3 : 1]);
  }

  private showNotification(message: string, type: (typeof NotificationTypes)[number], translate: boolean = true): void {
    this.globalNotificationsService.show({
      message: translate && !message.includes('view_translations.') ? `view_translations.${message}` : message,
      type,
      translate: translate,
      isPersistent: false,
      id: ''
    });
  }
}
